import { render, staticRenderFns } from "./modulesTable.vue?vue&type=template&id=18c9ea2e"
import script from "./modulesTable.vue?vue&type=script&lang=js"
export * from "./modulesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports